var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.082,
    height: 6.426,
    viewBox: "0 0 7.082 6.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106340",
    "data-name": "Path 106340",
    d: "M3.712,2.656a1.584,1.584,0,0,1,2.717,0L8.383,5.914a1.584,1.584,0,0,1-1.358,2.4H3.116a1.584,1.584,0,0,1-1.358-2.4Z",
    transform: "translate(8.611 8.313) rotate(180)",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.1faebde6e648b45618e33310c24df4b4.svg";
export { ForwardRef as ReactComponent };